module.exports = __webpack_public_path__ + "static/media/poster3.cbd49bf3.png";